<template>
  <div class="sideBar">
    <div class="colspan" id="publicPM">
      <ul class="clearfix">
        <a v-for="(item,index) in channleData" @click="channelGoto(item)" :key="item.id">
          <li
            ref="li"
            :class="[item.id == menuId ? 'current' : '',item.id != menuId&&item.id == hoverId ? 'hover' : ''] "
            :style="index==0 ? 'border-top:1px solid #ddd' : ''"
            @click="tab(item.id)"
            @mouseenter="enter(item.id)"
            @mouseleave="leave"
            :title="(item.title).length>=8?item.title:''"
          >
            <span :title="item.title">{{item.title}}</span>
            <span class="right">
              <i class="el-icon-arrow-right"></i>
            </span>
          </li>
        </a>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    if(this.title){
      let currentTitle = '';
      currentTitle = this.title;
      currentTitle = this.$store.state.webInfo.title +"-"+currentTitle;
      return {
        title: currentTitle
      };
    }
  },
  props: {
    positionData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      id: null,
      second_navId: null,
      menuId: null,
      hoverId: null,
      hover: false,
      channleData: [],
      title:''
    };
  },
  methods: {
    tab(id) {
      this.menuId = id;
    },
    enter(id) {
      this.hoverId = id;
    },
    leave() {
      this.hoverId = null;
    }
  },
  mounted() {},

  created() {
    this.id = this.$route.query.id;
    this.second_navId = this.$route.query.second_navId;
    this.menuId = this.second_navId ? this.second_navId : this.id;
    // this.getPositionData()
  },

  watch: {
    "$route.query.id": function(value) {
      this.id = value;
      this.menuId = value;
    },
    "$route.query.second_navId": function(value) {
      this.second_navId = value;
      this.menuId = this.second_navId ? this.second_navId : this.id;
    },
    positionData: function(value) {
      if (value) {
        this.channleData = value;
        
      }
    },
    menuId:function(value){
      let self =this;
      if(value && self.menuId&&  self.channleData.find(it=> it.id==self.menuId)){
        self.title = self.channleData.find(it=> it.id==self.menuId).title;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.sideBar {
    float: left;
    margin-right: 20px;
  .colspan {
    margin: 0 auto;
    // width: 1200px;
    > ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      // float: left;
      // margin-right: 20px;
      > a {
        text-decoration: none;
        > li {
          width: 230px;
          height: 60px;
          line-height: 60px;
          box-sizing: border-box;
          font-size: 18px;
          color: #888888;
          border: 1px solid #e5e5e5;
          padding: 0 10px;
          cursor: pointer;
          position: relative;
          border-top: 0px;
          > .right {
            position: absolute;
            right: 19px;
            top: 50%;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #fff;
            border-radius: 50%;
            color: #fff;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            transform: translateY(-50%);
          }
          > span {
            text-overflow: ellipsis;
            display: block;
            width: 160px;
            overflow: hidden;
            white-space: nowrap;
          }
          // :hover{
          // display: block;
          // width: 500px;
          // white-space: normal;
          // }
        }
        // 选择器选中了所有的li元素 ？？？
        // > li:nth-of-type(1){
        //     border-top: 1px solid #ddd;
        // }
      }
      > a > li.current {
        color: #fff;
      }
      > a > li.hover {
        background-color: #f3f3f3;
      }
    }
  }
}
#publicPM ul.clearfix{
 z-index:99;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/projectMenu.vue